// extracted by mini-css-extract-plugin
export default {"border":"style_border__RNG2f","bg":"style_bg__1gPtF","txt1":"style_txt1__pFziJ","txt2":"style_txt2__nKWn7","enableIcon":"style_enableIcon__uTGhr"};